import { Experience } from '@components'
import { GUI } from '@components/helpers'

export default function App() {
  return (
    <>
      <GUI />
      {/* <DoubleTapPreventer /> */}
      <Experience />
      {/* <Dashboard /> */}
    </>
  )
}
